export interface IAppPurchaseOffer {
  oneTimeTotalPrice: number;
  recurringTotalPrice: number;
  offerId: string;
  hasAppOverride: boolean;
  hasAppUpgrades: boolean;
}
